import apiB2b from '@/api/seller/B2b';

const defaultState = () => ({
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	alert: ''
});

const state = defaultState();

const getters = {};

const mutations = {
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearB2B(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	requestB2b({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiB2b.requestB2b(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(err)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},

	uploadImageB2b({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiB2b.uploadImage(params).then(({ data : { data }}) => {
				resolve(data.results);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},

	canRequestB2b({ dispatch }) {
		return new Promise((resolve, reject) => {
			apiB2b.canRequestB2b().then(() => {
				resolve();
			}).catch((err) => {
				reject()
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},

	success({commit}, response) {
		commit('saveResponse', response)
		commit('makeAlert', { code: 'success', type: 'success', message: response.message, show: true }, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			case 'error_multiple_alert':
			commit('multipleAlert', response.data.error)
			break;

			default:
			commit('makeAlert', { code: 'error_response', type: 'error', message: response.message, show: true }, { root: true });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};